import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { HeaderContainer } from "./styles";

type Props = {
  workTitle: string;
  workLocation: string;
  headerDateTime: string | undefined;
};

const Header = ({ workTitle, workLocation, headerDateTime }: Props) => {
  const { t } = useTranslation("order");

  const hasMultipleValues =
    [workTitle, workLocation, headerDateTime].filter(Boolean).length > 1;
  const workTitleAndWorkLocationEmpty = ![workTitle, workLocation].filter(
    Boolean,
  ).length;

  return (
    <HeaderContainer
      sx={{ cursor: "grab", gap: hasMultipleValues ? "1rem" : 0 }}
    >
      {workTitleAndWorkLocationEmpty ? (
        <Typography
          variant="header"
          sx={{ fontSize: "23px", fontWeight: 500, lineHeight: 1 }}
        >
          {t("orderRow")}
        </Typography>
      ) : (
        <>
          <Typography
            variant="header"
            sx={{ fontSize: "23px", fontWeight: 500, lineHeight: 1 }}
          >
            {workTitle}
          </Typography>
          <Typography>{workLocation}</Typography>
          {headerDateTime && <Typography>{headerDateTime}</Typography>}
        </>
      )}
    </HeaderContainer>
  );
};

export default Header;
